/* eslint-disable */

require('script-loader!file-saver');
// import XLSX from 'xlsx-style'
import XLSX from 'xlsx-js-style'

function generateArray(table) {
	var out = [];
	var rows = table.querySelectorAll('tr');
	var ranges = [];
	for (var R = 0; R < rows.length; ++R) {
		var outRow = [];
		var row = rows[R];
		var columns = row.querySelectorAll('td');
		for (var C = 0; C < columns.length; ++C) {
			var cell = columns[C];
			var colspan = cell.getAttribute('colspan');
			var rowspan = cell.getAttribute('rowspan');
			var cellValue = cell.innerText;
			if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

			//Skip ranges
			ranges.forEach(function(range) {
				if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
					for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
				}
			});

			//Handle Row Span
			if (rowspan || colspan) {
				rowspan = rowspan || 1;
				colspan = colspan || 1;
				ranges.push({
					s: {
						r: R,
						c: outRow.length
					},
					e: {
						r: R + rowspan - 1,
						c: outRow.length + colspan - 1
					}
				});
			};

			//Handle Value
			outRow.push(cellValue !== "" ? cellValue : null);

			//Handle Colspan
			if (colspan)
				for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
		}
		out.push(outRow);
	}
	return [out, ranges];
};

function datenum(v, date1904) {
	if (date1904) v += 1462;
	var epoch = Date.parse(v);
	return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
	var ws = {};
	var range = {
		s: {
			c: 10000000,
			r: 10000000
		},
		e: {
			c: 0,
			r: 0
		}
	};
	for (var R = 0; R != data.length; ++R) {
		for (var C = 0; C != data[R].length; ++C) {
			if (range.s.r > R) range.s.r = R;
			if (range.s.c > C) range.s.c = C;
			if (range.e.r < R) range.e.r = R;
			if (range.e.c < C) range.e.c = C;
			var cell = {
				v: data[R][C]
			};
			if (cell.v == null) continue;
			var cell_ref = XLSX.utils.encode_cell({
				c: C,
				r: R
			});

			if (typeof cell.v === 'number') cell.t = 'n';
			else if (typeof cell.v === 'boolean') cell.t = 'b';
			else if (cell.v instanceof Date) {
				cell.t = 'n';
				cell.z = XLSX.SSF._table[14];
				cell.v = datenum(cell.v);
			} else cell.t = 's';

			ws[cell_ref] = cell;
		}
	}
	if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
	return ws;
}

function Workbook() {
	if (!(this instanceof Workbook)) return new Workbook();
	this.SheetNames = [];
	this.Sheets = {};
}

function s2ab(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

export function export_table_to_excel(id) {
	var theTable = document.getElementById(id);
	var oo = generateArray(theTable);
	var ranges = oo[1];

	/* original data */
	var data = oo[0];
	var ws_name = "SheetJS";

	var wb = new Workbook(),
		ws = sheet_from_array_of_arrays(data);

	/* add ranges to worksheet */
	// ws['!cols'] = ['apple', 'banan'];
	ws['!merges'] = ranges;

	/* add worksheet to workbook */
	wb.SheetNames.push(ws_name);
	wb.Sheets[ws_name] = ws;

	var wbout = XLSX.write(wb, {
		bookType: 'xlsx',
		bookSST: false,
		type: 'binary'
	});

	saveAs(new Blob([s2ab(wbout)], {
		type: "application/octet-stream"
	}), "test.xlsx")
}

export function export_json_to_excel({
	titleName,
	multiHeader = [],
	header,
	data,
	filename,
	border = true,
	autoWidth = true,
	bookType = 'xlsx'
} = {}) {

	/* original data */
	filename = filename || 'excel-list'
	data = [...data]
	data.unshift(header);

	//不为空时添加标题
	if (titleName != "") {
		var title = [];
		for (let i in header) {
			if (i == 0) {
				title.push(titleName);
			} else {
				title.push('');
			}
		}
		data.unshift(title);
	}

	for (let i = multiHeader.length - 1; i > -1; i--) {
		data.unshift(multiHeader[i])
	}

	var ws_name = "SheetJS";
	var wb = new Workbook(),ws = sheet_from_array_of_arrays(data);
	
	/* add worksheet to workbook */
	wb.SheetNames.push(ws_name);
	wb.Sheets[ws_name] = ws;
	var dataInfo = wb.Sheets[wb.SheetNames[0]];
	console.log(dataInfo)

	var borderAll = {};

	if (border) {
		//单元格外侧框线
		borderAll = {
			top: {
				style: 'thin'
			},
			bottom: {
				style: 'thin'
			},
			left: {
				style: 'thin'
			},
			right: {
				style: 'thin'
			}
		};
	}

	//合并title行的单元格
	if (titleName != "") {
		var titleStart = dataInfo["!ref"].split(':')[0].toString(); //需要合并的初始位置(例:A1)
		var titleEnd = deleteNum(dataInfo["!ref"].split(':')[1].toString()) + "1"; //列表所占的最后一列(例:F1)
		var merges = [titleStart + ':' + titleEnd]; //合并范围
		console.log(merges)
		//合并单元格
		if (merges.length > 0) {
			if (!ws['!merges']) ws['!merges'] = [];
			merges.forEach(item => {
				ws['!merges'].push(XLSX.utils.decode_range(item))
			})
		}
		
		//设置主标题样式
		dataInfo["A1"].s = {
			font: {
				name: '宋体',
				sz: 18,
				color: {
					rgb: "00000000"
				},
				bold: true,
				italic: false,
				underline: false
			},
			alignment: {
				//居中设置
				horizontal: "center",
				vertical: "center"
			},
			border: borderAll,
			//fill: {
			//   fgColor: {rgb: "008000"},
			// },
		};
	}

	//给所有单元格加上边框
	for (var i in dataInfo) {
		if (i == '!ref' || i == '!merges' || i == '!cols' || i == 'A1') {
			if (i == 'A1' && titleName == "") {
				dataInfo[i + ''].s = {
					border: borderAll,
					font: {
						bold: true
					}
				}
			}
		} else {
			//有标题就将第二行head字体加粗
			if (titleName != "") {
				if (deleteLetter(i) == "2") {
					dataInfo[i + ''].s = {
						border: borderAll,
						font: {
							bold: true
						}
					}
				} else {
					dataInfo[i + ''].s = {
						border: borderAll
					}
				}
			} else {
				//无标题head在第一行
				if (deleteLetter(i) == "1") {
					dataInfo[i + ''].s = {
						border: borderAll,
						font: {
							bold: true
						}
					}
				} else {
					dataInfo[i + ''].s = {
						border: borderAll
					}
				}
			}

		}
	}

	/*设置worksheet列宽自适应*/
	if (autoWidth) {
		const colWidth = data.map(row => row.map(val => {
			/*先判断是否为null/undefined*/
			if (val == null) {
				return {
					'wch': 10
				};
			}
			/*再判断是否为中文*/
			else if (val.toString().charCodeAt(0) > 255) {
				return {
					'wch': val.toString().length * 2
				};
			} else {
				return {
					'wch': val.toString().length
				};
			}
		}))
		/*以第一行为初始值,有标题时取第二行(标题合并单元格后第一列会超级长)*/
		let result = titleName == "" ? colWidth[0] : colWidth[1];
		for (let i = 1; i < colWidth.length; i++) {
			for (let j = 0; j < colWidth[i].length; j++) {
				if (result[j]['wch'] < colWidth[i][j]['wch']) {
					result[j]['wch'] = colWidth[i][j]['wch'];
				}
			}
		}
		ws['!cols'] = result;
	}
	
	// console.log(merges)
	// console.log(dataInfo)

	var wbout = XLSX.write(wb, {
		bookType: bookType,
		bookSST: false,
		type: 'binary'
	});
	saveAs(new Blob([s2ab(wbout)], {
		type: "application/octet-stream"
	}), `${filename}.${bookType}`);

}

function deleteNum(str) {
	let reg = /[0-9]+/g;
	let str1 = str.replace(reg, "");
	return str1;
}

function deleteLetter(str) {
	var result;
	var reg = /[a-zA-Z]+/; //[a-zA-Z]表示匹配字母，g表示全局匹配
	while (result = str.match(reg)) { //判断str.match(reg)是否没有字母了
		str = str.replace(result[0], ''); //替换掉字母  result[0] 是 str.match(reg)匹配到的字母
	}
	return str;
}
